module.exports = __webpack_public_path__ + "static/media/Developmenticon03@3x.cc74fe52.png";